import React from "react";

const Content = ({ children, className = "", myId = "" }) => {
  return (
    <main id="ContentBox" style={{ minHeight: "100vh" }}>
      <div className={className} id={myId}>
        {children}
      </div>
    </main>
  );
};

Content.HeaderPrimary = React.forwardRef((props, ref) => (
  <section {...props} className={`header-primary d-flex ${props.className ?? ""}`} ref={ref}>
    {props.children}
  </section>
));

Content.HeaderPrimary.displayName = "Content.HeaderPrimary";

Content.HeaderSecondary = React.forwardRef((props, ref) => (
  <section {...props} className={`header-secondary ${props.className ?? ""}`} ref={ref}>
    {props.children}
  </section>
));

Content.HeaderSecondary.displayName = "Content.HeaderSecondary";

Content.Body = React.forwardRef((props, ref) => (
  <section {...props} className={`page-content ${props.className ?? ""}`} ref={ref}></section>
));

Content.Body.displayName = "Content.Body";

export default Content;
